import { store } from '../store';
import clientConfig from '../clientConfig';

// Relative the SSO session is scoped to (set from the SSO response in
// completeSsoLogin). Only honoured for clients with `autoSelectSsoRelative`;
// returns undefined otherwise or when the backend sent no / a sentinel value.
export const getSsoRelativeId = () => {
  if (!clientConfig.autoSelectSsoRelative) return undefined;
  const relativeId = store.getState().user?.relativeId;
  if (relativeId === undefined || relativeId === null) return undefined;
  if (relativeId === '' || Number(relativeId) === -1) return undefined;
  return relativeId;
};
